<template>
  <div class="log">
    <v-icon
      color="brown darken-1"
      class="white--text"
      flat
      @click.stop="dialog = true"
      @click="getData"
      title="Notification"
      >email</v-icon
    >
    <!-- <button
      @click.stop="dialog = true"
      title="View Customer Details"
      @click="checkStatus"
      class="view-ass-btn"
    >Email</button>-->

    <v-dialog
      v-model="dialog"
      persistent
      max-width="28rem"
      content-class="email-updates-dialog"
    >
      <v-form ref="form" onSubmit="return false;">
        <v-card class="email-updates-card">
          <header class="email-updates-header">
            <div class="email-updates-header__brand">
              <div class="email-updates-header__badge" aria-hidden="true">
                <v-icon>email</v-icon>
              </div>
              <h2 class="email-updates-title">Manage Email Updates</h2>
            </div>
            <v-btn
              icon
              class="email-updates-close"
              title="Close"
              @click.prevent="dialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </header>
          <v-progress-linear
            indeterminate
            color="trukkin-theme darken-2"
            v-show="loading"
          ></v-progress-linear>
          <div class="email-updates-shell">
            <v-card-text class="email-updates-body">
              <div class="email-updates-controls">
                <div class="email-updates-option">
                  <v-switch
                    v-model="ReceiveEmails"
                    color="green"
                    @change="emailNoyify"
                    label="Receive Emails"
                    class="switch-permission-type email-updates-switch"
                    hide-details
                  ></v-switch>
                </div>
                <div class="email-updates-option">
                  <v-switch
                    v-model="JobStatus"
                    color="green"
                    @change="emailNoyify"
                    :disabled="!ReceiveEmails || this.radios == 'Summary'"
                    label="Job Status Emails"
                    class="switch-permission-type email-updates-switch"
                    hide-details
                  ></v-switch>
                </div>
                <div class="email-updates-option">
                  <v-switch
                    v-model="AssignmentStatus"
                    :disabled="!ReceiveEmails || this.radios == 'Summary'"
                    @change="emailNoyify"
                    color="green"
                    label="Assignment Status Emails"
                    class="switch-permission-type email-updates-switch"
                    hide-details
                  ></v-switch>
                </div>
                <div class="email-updates-type">
                  <div class="email-updates-type-title">
                    Email Type
                  </div>
                  <v-radio-group
                    class="email-updates-radio-group mt-0 pt-0"
                    @change="emailNoyify"
                    v-model="radios"
                    :disabled="!ReceiveEmails"
                    row
                    :mandatory="true"
                    hide-details
                  >
                    <v-radio
                      label="All"
                      value="All"
                      color="green"
                      class="email-updates-radio"
                    ></v-radio>
                    <v-radio
                      label="Summary"
                      value="Summary"
                      color="green"
                      class="email-updates-radio"
                    ></v-radio>
                  </v-radio-group>
                </div>
              </div>
            </v-card-text>
            <v-snackbar
              :timeout="3000"
              bottom
              color="red darken-2"
              v-model="x.error"
              class="white--text"
              v-if="x.error"
              >{{ x.error }}</v-snackbar
            >
          </div>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import { StorageKeys } from "../../constants/constants";
export default {
  data() {
    return {
      loading: false,
      x: {
        error: null,
      },
      radios: "All",
      toggle_exclusive: 0,
      ReceiveEmails: null,
      JobStatus: null,
      AssignmentStatus: null,
      processing: false,
      reason: "",
      dialog: false,

      loading: false,
    };
  },
  props: {
    detail: Object,
  },
  created() {},

  methods: {
    getData() {
      this.loading = true;
      let Url = "/dmsAdmin/getUserEmailRoles";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };

      let body = {
        userId: this.detail.userId.toString(),
      };
      this.axios.post(this.constants.apiUrl + Url, body, config).then(
        (response) => {
          if (response.data.statusCode == 200) {
            this.radios = response.data.data[0].emailType;
            this.JobStatus = response.data.data[0].jobStatusForEmail;
            this.AssignmentStatus =
              response.data.data[0].assignmentStatusForEmail;
            this.ReceiveEmails = response.data.data[0].isReceiveEmail;
            this.loading = false;
          }
        },
        (error) => {
          this.loading = false;

          this.x.error = error.response.data.message;
          // setTimeout(()=>{this.error='';}, 6000);
        }
      );
    },
    emailNoyify() {
      this.checkStatus();
      this.loading = true;
      let Url = "/dmsAdmin/editUserEmailRoles";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };

      let body = {
        userId: this.detail.userId.toString(),
        emailType: this.radios,
        jobStatusForEmail: this.JobStatus,
        assignmentStatusForEmail: this.AssignmentStatus,
        isReceiveEmail: this.ReceiveEmails,
      };
      this.axios.post(this.constants.apiUrl + Url, body, config).then(
        (response) => {
          if (response.data.statusCode == 200) {
            this.loading = false;
          }
        },
        (error) => {
          this.loading = false;
          this.x.error = error.response.data.message;
        }
      );
    },

    checkStatus() {
      if (this.radios == "Summary") {
        this.JobStatus = false;
        this.AssignmentStatus = false;
      }
      if (this.ReceiveEmails == false) {
        this.JobStatus = false;
        this.radios = "All";
        this.AssignmentStatus = false;
      }
    },
  },
};
</script>
<style>
.application .v-dialog.email-updates-dialog {
  border-radius: 1rem !important;
  max-width: min(28rem, calc(100vw - 2rem)) !important;
  overflow: hidden !important;
  width: min(28rem, calc(100vw - 2rem)) !important;
}

.application .v-dialog.email-updates-dialog .email-updates-card {
  background: #ffffff !important;
  border: 0 !important;
  border-radius: 1rem !important;
  box-shadow: none !important;
  display: flex;
  flex-direction: column;
  max-height: min(82vh, 36rem) !important;
  overflow: hidden !important;
  padding: 0 !important;
  width: 100% !important;
}

.application .v-dialog.email-updates-dialog .v-toolbar,
.application .v-dialog.email-updates-dialog .v-card__title {
  background: transparent !important;
  border-bottom: 0 !important;
  min-height: 0 !important;
  padding: 0 !important;
}

.application .v-dialog.email-updates-dialog .email-updates-header {
  align-items: center;
  background:
    radial-gradient(circle at 100% 0%, rgba(245, 130, 32, 0.14), transparent 42%),
    linear-gradient(135deg, #fff7ed 0%, #ffffff 55%, #f4f7fb 100%);
  border-bottom: 0.0625rem solid #fed7aa;
  box-sizing: border-box;
  display: flex;
  flex: 0 0 auto;
  gap: 0.75rem;
  justify-content: space-between;
  min-height: 3.5rem;
  overflow: hidden;
  padding: 0.85rem 1rem 0.85rem 1.1rem;
  width: 100%;
}

.application .v-dialog.email-updates-dialog .email-updates-header__brand {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  gap: 0.7rem;
  min-width: 0;
}

.application .v-dialog.email-updates-dialog .email-updates-header__badge {
  align-items: center;
  background: linear-gradient(160deg, #1c2b5f 0%, #2a3f7a 100%);
  border-radius: 0.7rem;
  box-shadow: 0 0.35rem 0.75rem rgba(28, 43, 95, 0.22);
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.35rem;
  justify-content: center;
  width: 2.35rem;
}

.application .v-dialog.email-updates-dialog .email-updates-header__badge .v-icon {
  color: #ffffff !important;
  font-size: 1.05rem !important;
}

.application .v-dialog.email-updates-dialog .email-updates-title {
  color: #1c2b5f !important;
  -webkit-text-fill-color: #1c2b5f !important;
  flex: 1 1 auto;
  font-size: 1rem !important;
  font-weight: 800 !important;
  letter-spacing: -0.01em !important;
  line-height: 1.3 !important;
  margin: 0 !important;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.application .v-dialog.email-updates-dialog .email-updates-close {
  color: #74716a !important;
  flex: 0 0 auto;
  height: 2rem !important;
  margin: 0 !important;
  min-width: 2rem !important;
  width: 2rem !important;
}

.application .v-dialog.email-updates-dialog .email-updates-close .v-icon {
  color: #74716a !important;
}

.application .v-dialog.email-updates-dialog .email-updates-body.v-card__text,
.application .v-dialog.email-updates-dialog .email-updates-body {
  flex: 1 1 auto !important;
  max-height: none !important;
  overflow: auto !important;
  padding: 1.35rem 1.25rem 1.5rem !important;
}

.application .v-dialog.email-updates-dialog .email-updates-controls {
  display: flex;
  flex-direction: column;
  gap: 1.15rem;
  margin: 0;
  max-width: none;
  width: 100%;
}

html.oms-night-mode .application .v-dialog.email-updates-dialog .email-updates-card {
  background: var(--oms-surface) !important;
}

html.oms-night-mode .application .v-dialog.email-updates-dialog .email-updates-header {
  background: var(--oms-table-header-bg, #2a2f3a) !important;
  border-color: var(--oms-border) !important;
}

html.oms-night-mode .application .v-dialog.email-updates-dialog .email-updates-title {
  color: #f8bd82 !important;
  -webkit-text-fill-color: #f8bd82 !important;
}
</style>
<style scoped>
.break_long_text {
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
}
.switch-permission-type {
  width: 100%;
  display: block;
  float: none;
}
.user {
  padding: 10px;
}
.view-ass-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #c87ffe;
  border: 2px solid indigo;
  padding: 2px 5px;
  border-radius: 5px;
}
.email-updates-shell {
  display: block;
  min-width: 0;
}
.email-updates-option {
  display: flex;
  justify-content: flex-start;
  min-height: 1.75rem;
  min-width: 0;
  width: 100%;
}
.email-updates-switch {
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
}
.email-updates-switch ::v-deep .v-input__control {
  min-height: 1.75rem;
  width: 100%;
}
.email-updates-switch ::v-deep .v-input__slot {
  align-items: center;
  margin: 0 !important;
}
.email-updates-switch ::v-deep .v-input--selection-controls__input {
  margin-right: 0.875rem;
}
.email-updates-switch ::v-deep .v-label {
  color: #2f343b !important;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.45;
  white-space: normal;
}
.email-updates-type {
  margin-top: 0.25rem;
}
.email-updates-type-title {
  color: #7b8088;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 0.5rem;
}
.email-updates-radio-group {
  margin: 0 !important;
  padding: 0 !important;
}
.email-updates-radio-group ::v-deep .v-input__control,
.email-updates-radio-group ::v-deep .v-input__slot {
  margin: 0 !important;
}
.email-updates-radio-group ::v-deep .v-input--radio-group__input {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.email-updates-radio {
  margin: 0 !important;
  padding: 0 !important;
}
.email-updates-radio ::v-deep .v-label {
  color: #2f343b !important;
  font-size: 0.875rem;
  font-weight: 700;
}

html.oms-night-mode .application .email-updates-switch ::v-deep .v-label,
html.oms-night-mode .application .email-updates-radio ::v-deep .v-label {
  color: var(--oms-ink-strong) !important;
}
html.oms-night-mode .application .email-updates-type-title {
  color: var(--oms-muted) !important;
}

@media (max-width: 40rem) {
  .email-updates-body.v-card__text {
    min-height: 0;
    padding: 1.15rem 1rem 1.25rem !important;
  }
}
</style>
